import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ListGroup, ListGroupItem, Panel } from 'react-bootstrap';
import MapViewType from './MapViewType.jsx';
import GroupByList from './GroupByList.jsx';
import { projectHasKml } from '../util/projectMap.js';

import { useStateValue } from '../context/state.jsx';
import { setProjectViewType, setProjectGroupBy, setProjectGroupByActivityCode } from '../context/datasets.js';

const MAP_UNAVAILABLE_TITLE = 'Map requires KML — configure in Project Setup.';

const ProjectViewTypeList = ({ datasetInfo }) => {
	const [{
		projectViewType,
		projectGroupBy,
		projectGroupByActivityCode,
		projectMapGroupBy,
		projectActivityCodesTree,
		projectActivityCodesTreeSequence
	}, dispatch] = useStateValue();

	const projectViewTypeListItemClick = type => {
		dispatch(setProjectViewType(type));
		if (type !== 'Group List') {
			dispatch(setProjectGroupBy(null));
			dispatch(setProjectGroupByActivityCode(null));
		}
	};

	const choices = [
		//{name: 'Recent Feed', text: 'Recent Feed'},
		{name: 'WBS List', text: 'WBS List'},
		{name: 'Calendar', text: 'Calendar'},
		{name: 'Resource Graphs', text: 'Resource Graphs'}
	];

	const {
		activityCodeTypes
	} = datasetInfo || {};

	const mapAvailable = projectHasKml(datasetInfo);

	const mapViewType = mapAvailable
		? (
			<MapViewType
				projectViewType={projectViewType}
				projectMapGroupBy={projectMapGroupBy}
				activityCodeTypes={activityCodeTypes} />
		)
		: (
			<div className="projectViewTypeListItemWrapper mapUnavailableItem">
				<ListGroupItem
					onClick={() => { projectViewTypeListItemClick('Map'); }}
					title={MAP_UNAVAILABLE_TITLE}
					aria-description={MAP_UNAVAILABLE_TITLE}>
					<input
						type="radio"
						className="projectViewTypeRadio"
						name="projectViewTypeRadio"
						checked={projectViewType === 'Map'}
						readOnly
						aria-label="Map, unavailable, no KML configured" />
					Map
					<span className="mapUnavailableBadge">No KML — disabled</span>
				</ListGroupItem>
			</div>
		);

	const listGroupItems = choices.map((item, index) => {
		const checked = projectViewType === item.name;
		const classes = classnames('projectViewTypeListItemWrapper', {'no-bottom-border': item.name === 'Group List'});
		return (
			<div
				key={index}
				className={classes}>
				<ListGroupItem
					onClick={() => { projectViewTypeListItemClick(item.name); }}>
					<input
						type="radio"
						className="projectViewTypeRadio"
						name="projectViewTypeRadio"
						checked={checked}
						readOnly
						aria-label={item.text} />
					{item.text}
				</ListGroupItem>
			</div>
		);
	});

	return (
		<Panel
			className="projectViewTypeList"
			defaultExpanded>
			<Panel.Heading>
				<Panel.Title toggle>Grouping</Panel.Title>
			</Panel.Heading>
			<Panel.Collapse>
				<ListGroup>
					{listGroupItems}
					{mapViewType}
					<GroupByList
						projectViewType={projectViewType}
						projectGroupBy={projectGroupBy}
						projectGroupByActivityCode={projectGroupByActivityCode}
						projectViewTypeListItemClick={projectViewTypeListItemClick}
						projectActivityCodesTree={projectActivityCodesTree}
						projectActivityCodesTreeSequence={projectActivityCodesTreeSequence} />
				</ListGroup>
			</Panel.Collapse>
		</Panel>
	);
};

ProjectViewTypeList.propTypes = {
	datasetInfo: PropTypes.object
};

export default ProjectViewTypeList;
